import commonService from "./common";
import configDirective from "@/common/directive/config-directive";
import AuthService from "./auth-service";
import Vue from "vue";

const provisioningService = {
	/* provisioning */
	submitAddSubscriber(formData) {
		let {
			iccidInfo,
			imsiInfo,
			msisdnInfo,
			minInfo,
			subscriberNameInfo,
			hssProfileInfo,
			hlrProfileInfo,
			busyActive,
			busyNumber,
			busyProvision,
			notAvailableActive,
			notAvailableNumber,
			notAvailableProvision,
			notReachableProvision,
			notReachableNumber,
			notReachableActive,
			unconditionalActive,
			unconditionalNumber,
			unconditionalProvision,
			clip_profile_status,
			callWaiting,
			enableData,
			localData,
			mms,
			sms,
			dataPlanInfo,
			tis,
			lte,
			voLte,
			voWifi,
		} = formData;
		let param = `StartQueue&action=AddSubscriber&iccid=${iccidInfo}&imsi=${imsiInfo}&msisdn=${msisdnInfo}&min=${minInfo}&subscribername=${subscriberNameInfo}&hssprofile=${hssProfileInfo}&hlrprofile=${hlrProfileInfo}&cfb_hlr_status=${busyActive}&cfb_number=${busyNumber}&cfb_profile_status=${busyProvision}&cfna_hlr_status=${notAvailableActive}&cfna_number=${notAvailableNumber}&cfna_profile_status=${notAvailableProvision}&cfnr_hlr_status=${notReachableActive}&cfnr_number=${notReachableNumber}&cfnr_profile_status=${notReachableProvision}&cfu_hlr_status=${unconditionalActive}&cfu_number=${unconditionalNumber}&cfu_profile_status=${unconditionalProvision}&clip_profile_status=${clip_profile_status}&cw_profile_status=${callWaiting}&data=${enableData}&local_data_only=${localData}&mms=${mms}&sms_profile_status=${sms}&data_plan_name=${dataPlanInfo}&tis=${tis}&lte=${lte}&volte=${voLte}&vowifi=${voWifi}&debug=0&delay=0`;
		if (!configDirective.hasPolling()) {
			param = `AddSubscriber&iccid=${iccidInfo}&imsi=${imsiInfo}&msisdn=${msisdnInfo}&min=${minInfo}&subscribername=${subscriberNameInfo}&hssprofile=${hssProfileInfo}&hlrprofile=${hlrProfileInfo}&cfb_hlr_status=${busyActive}&cfb_number=${busyNumber}&cfb_profile_status=${busyProvision}&cfna_hlr_status=${notAvailableActive}&cfna_number=${notAvailableNumber}&cfna_profile_status=${notAvailableProvision}&cfnr_hlr_status=${notReachableActive}&cfnr_number=${notReachableNumber}&cfnr_profile_status=${notReachableProvision}&cfu_hlr_status=${unconditionalActive}&cfu_number=${unconditionalNumber}&cfu_profile_status=${unconditionalProvision}&clip_profile_status=${clip_profile_status}&cw_profile_status=${callWaiting}&data=${enableData}&local_data_only=${localData}&mms=${mms}&sms_profile_status=${sms}&data_plan_name=${dataPlanInfo}&tis=${tis}&lte=${lte}&volte=${voLte}&vowifi=${voWifi}&debug=0&delay=0`;
		}
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitSuspendSubscriber(imsi) {
		let param = `SuspendSubscriber&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitResumeSubscriber(imsi, lteStatus = 1) {
		let param = `UnsuspendSubscriber&imsi=${imsi}&hss_data=${lteStatus}&aaa_data=1`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitTerminateSubscriber(imsi) {
		let param = `StartQueue&action=RemoveSubscriber&imsi=${imsi}`;
		if (!configDirective.hasPolling()) {
			param = `RemoveSubscriber&imsi=${imsi}`;
		}
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitRemoveSubscriber(imsi) {
		let param = `StartQueue&action=RemoveSubscriber&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitModifySubscriber(imsi, action, value) {
		let param = `ModifySubscriber&imsi=${imsi}&action=${action}&value=${value}`;
		return commonService
			.commonAPI(param)
			.then(async response => {
				let message = response.data.message;
				let isError = JSON.stringify(message).includes("error") || JSON.stringify(message).includes("FAIL");
				await AuthService.setActivityLog(`Mobility: Set ${action}`, message, isError ? 1 : 0).catch(err => {
					if (process.env.NODE_ENV === "dev") {
						console.error("[DEBUG][SimeDetailCard.vue] logEvent[CATCH][ERROR]", err);
					}
				});
				return message;
			})
			.catch(error => console.error(error));
	},

	/* POLLING */
	getPollQueue(id) {
		let param = `IOT_PollQueue&id=${id}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getPollUntilDone: async (id, timeout, interval, callback) => {
		if (typeof id === "undefined" || id < 1) return "No ID";
		let endTime = Number(new Date()) + (timeout || 2000);
		interval = interval || 1000;
		let checkCondition = function (resolve, reject) {
			provisioningService
				.getPollQueue(id)
				.then(result => {
					//console.log('poll status:'+result.status.toString())
					//console.log("poll result:",result)
					callback(result);
					if (result.status.toString().includes("DONE")) {
						resolve(result);
					} else if (result.status.toString().includes("ERROR")) {
						reject(result);
					} else if (Number(new Date()) < endTime) {
						setTimeout(checkCondition, interval, resolve, reject);
					} else {
						reject("timed out for queueid:" + id + " - " + arguments);
					}
				})
				.catch(err => {
					console.error("polling error:", err);
				});
		};
		return new Promise(checkCondition);
	},

	/* hss */
	changeHssProfile(imsi, roaming, hssProfile) {
		let param = `ChangeHssProfile&imsi=${imsi}&profile_name=${hssProfile}&geography=${roaming}&staticlp=`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	registerHss(imsi, hssProfile) {
		let param = `RegisterHss&imsi=${imsi}&staticlp=&lteTemplate=${hssProfile}&reset=1&lte=1`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	/* data plans */
	submitAddDataPlan(msisdn, imsi, dataplan) {
		let param = `IOT_AddSubscsriberDataPlan&msisdn=${msisdn}&imsi=${imsi}&dataPlan=${dataplan}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	deleteDataBucket(dataGroup) {
		let param = `IOT_DeleteDataBucket&dataGroup=${dataGroup}&customerGroup='Administrator'`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getMsisdnList() {
		let params = `IOT_GetMsisdnList`;
		return commonService
			.commonAPI(params)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitSimpleActivate({imsi, msisdn, product}) {
		const params = `IOT_Activate&imsi=${imsi}&msisdn=${msisdn}&product=${product}`;
		return commonService
			.commonAPI(params)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitSimpleTerminate(imsi) {
		const params = `IOT_Terminate&imsi=${imsi}&return_stock=KeepProperties`;
		// return commonService
		// 	.commonAPI(params)
		// 	.then(response => response.data.message)
		// 	.catch(error => console.error(error));

		let headers = {
			headers: {
				"Content-Type": "application/json",
				"x-api-key": `${process.env.VUE_APP_CONFIG_APIKEY}`,
			},
		};
		let url = `${process.env.VUE_APP_CONFIG_BASEURL}?method=${params}`;
		return Vue.axios.get(url, headers, {timeout: 45000}).catch(err => {
			console.log(err);
			console.log(err.code);
			console.log(er.message);
			console.log(err.stack);
		});
	},

	// let url = `${baseurl}?method=esim_getprofiletypes&role=${role}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
	// return Vue.axios.get(url, headers);
	// axios.get('https://example.com/api', {
	// 	timeout: 30000 // 30 seconds in milliseconds
	// })
	// 	.then(response => {
	// 		// Handle the response
	// 	})
	// 	.catch(error => {
	// 		// Handle the error
	// 	});

	submitSimpleSuspend(imsi) {
		const params = `IOT_Suspend&imsi=${imsi}`;
		return commonService
			.commonAPI(params)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	submitSimpleResume(imsi) {
		const params = `IOT_Resume&imsi=${imsi}`;
		return commonService
			.commonAPI(params)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},
};

export default provisioningService;
